module.exports = __webpack_public_path__ + "static/media/image4.1b246692.png";